import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cn from 'classname';

import PromoUpload from '../../../../shared/form-elements/promo-upload';

const propTypes = {
	promoData: PropTypes.object,
	uploadFile: PropTypes.func,
	promoItemDelete: PropTypes.func,
	promoSave: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func,
	promoChangeCategory: PropTypes.func
};

const Promo = props => (
	<div className="promo-form__wrap">
		<div className="promo-form__wrap-categories">
			{ props.promoData.categories.map(entity => (
				<a
					key={entity.id}
					href="javascript:;"
					onClick={() => props.promoChangeCategory(entity.id)}
					className={cn('category', entity.isActive && 'category--active')}>{entity.text}</a>
			)) }
		</div>
		{ props.promoData.links.length > 0 && (
			<div>
				<div className="items clearfix">
					{ props.promoData.links.map((link, index) => (
						<div className="item-container promo-item" key={index}>
							{ link.shouldEmbedPdf && (
								<div className="promo-item__embed">
									<object
										width="400"
										height="500"
										type="application/pdf"
										data={`${link.file}?#toolbar=0&navpanes=0&scrollbar=0`}>
										<a href={link.file}>Download pdf</a>
									</object>
								</div>
							) }
							{!link.shouldEmbedPdf && renderFile(link.file)}
							<div className="promo-item__meta">
								<a
									href="#"
									className="delete"
									onClick={ e => {
										e.preventDefault();
										if (confirm('Delete item?')) {
											props.promoItemDelete(index);
										}
									}}>Удалить</a>
							</div>
						</div>
					)) }
					{ props.can('edit') && (
						<div className="item-container upload-item">
							<PromoUpload
								title={props.intl('Attach promo')}
								accent={props.intl('The total size of uploaded files should not exceed 5 Mb')}
								upload={props.uploadFile}/>
						</div>
					)}
				</div>
			</div>
		)}

		{ !props.promoData.links.length && props.can('edit') && (
			<PromoUpload
				title={props.intl('Attach promo')}
				accent={props.intl('The total size of uploaded files should not exceed 5 Mb')}
				upload={props.uploadFile}/>
		)}

		{ props.promoData.isDirty && (
			<div className="buttons-wrap">
				{ props.can('edit') && (
					<button
						className="ui-btn ui-btn-primary"
						onClick={props.promoSave}>{props.intl('Save')}</button>
				)}

				<Link to='programs/' className="ui-btn ui-btn-cancel">{ props.intl('Cancel') }</Link>
			</div>
		) }

	</div>
);

Promo.propTypes = propTypes;

const extensions = {
	video: ['mp4', 'avi', 'mkv', 'mov', 'flv', 'vob', 'wmv', 'mpeg', 'ogg', 'webm']
};

function renderFile(link) {
	const extension = link.split('.').pop().toLowerCase();

	return extensions.video.includes(extension) ? (
		<video src={link} height={180} width={303} controls>
			Sorry, your browser doesn't support embedded videos,
			but don't worry, you can <a href={link}>download it</a>
			and watch it with your favorite video player!
		</video>
	) : (
		<div className="promo-item__img" style={{backgroundImage: `url(${link})`}} />
	);
}

export default Promo;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/promo/main.js